
import { STATE_CODES } from '@constants/common/statesList';

export const getStateName = stateCode => {
    return (state => state ? state.stateName : '')(STATE_CODES.find(s => s.stateCode === stateCode));
};